import { useState } from "react";
import { useLocalState } from "../state/LocalStateProvider";
import { TipComposer } from "./TipComposer";
import { seatKey } from "../lib/contribution-client";
import { isAppsInTossChannel } from "../lib/channel";
export function NextDayPrompt() {
	const { state } = useLocalState();
	const [dismissed, setDismissed] = useState(false),
		[open, setOpen] = useState(false),
		[published, setPublished] = useState(false);
	const plan = [state.viewingPlan, ...state.upcomingPlans].find((p) => {
		const elapsed = Date.now() - Date.parse(p.startsAt);
		return elapsed > 0 && elapsed < 7 * 86_400_000;
	});
	const seat = plan?.candidateSnapshot;
	const id = plan?.id ?? `${plan?.eventTitle}:${plan?.startsAt}`;
	let stored = false;
	try {
		stored = localStorage.getItem(`anjabom.after-visit.${id}`) !== null;
	} catch {
		stored = true;
	}
	if (isAppsInTossChannel() || !plan || !seat || dismissed || stored)
		return null;
	const dismiss = (value: string) => {
		localStorage.setItem(`anjabom.after-visit.${id}`, value);
		setDismissed(true);
	};
	return (
		<section className="stack">
			<h2>{plan.eventTitle}, 그 자리 어땠어요?</h2>
			<p>
				{seat.sectionCode} {seat.rowLabel}열 {seat.seatNumber}번에 앉아본 경험이
				다음 사람에게 도움이 돼요.
			</p>
			<div className="inline">
				<button className="button" onClick={() => setOpen(true)}>
					앉아본 한 줄 남기기
				</button>
				<button className="button" onClick={() => dismiss("later")}>
					나중에
				</button>
				<button className="button" onClick={() => dismiss("not_attended")}>
					안 갔어요
				</button>
			</div>
			{open ? (
				<TipComposer
					seatKey={seatKey(seat)}
					onClose={() => {setOpen(false); if(published) dismiss("published");}}
					onPublished={() => setPublished(true)}
				/>
			) : null}
		</section>
	);
}
